import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkItemSelectTypeComponent } from './work-item-select-type.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [WorkItemSelectTypeComponent],
  exports: [
    WorkItemSelectTypeComponent
  ]
})
export class WorkItemSelectTypeModule { }
